export const ENVIRONMENT_CDN_BASE_PATH: Record<string, string> = {
  local: '/',
  development: '/content/spa_buyer_portal/dist/',
  integration: 'https://microapps.integration.zone/b2b-buyer-portal/',
  staging: '/content/spa_buyer_portal/dist/',
  production: '/content/spa_buyer_portal/dist/',
};
